export default {
  convert({
    effective_timerange: effectiveTimerange,
    id,
    messages,
    total_results: total,
    type
  }) {
    return {
      effectiveTimerange,
      id,
      messages,
      total,
      type
    };
  }
};
